"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _brandedAppsMetadata = require("src/branded-apps-metadata");
var _constants = require("libs/utils/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var PROVIDERS = [{
  id: 'sso_google',
  type: 'google',
  name: 'Google'
}, {
  id: 'sso_oauth2',
  type: 'oauth2',
  name: 'OAuth2'
}, {
  id: 'saml',
  type: 'saml',
  name: 'SAML'
}, {
  id: 'openidconnect',
  type: 'openidconnect',
  name: 'OpenID Connect'
}];
var PROVIDERS_FORMS = {
  google: _.clone(_brandedAppsMetadata.FORMS.sso.sso_google),
  oauth2: _.clone(_brandedAppsMetadata.FORMS.sso.sso_oauth2),
  saml: _.clone(_brandedAppsMetadata.FORMS.sso.saml),
  openidconnect: _.clone(_brandedAppsMetadata.FORMS.sso.openidconnect)
};
var PROVIDERS_EXTRAS = {
  saml: {
    urlConfigurable: true,
    fileConfigurable: true,
    metadataUrl: _constants.APP_BRANDING_SSO_SAML_METADATA_ENDPOINT,
    configUrl: _constants.APP_BRANDING_SSO_SAML_CONFIG_ENDPOINT
  },
  openidconnect: {
    urlConfigurable: true,
    configUrl: _constants.APP_BRANDING_SSO_OPEN_ID_DISCOVERY_ENDPOINT
  }
};
module.exports = /* @ngInject */["modalService", "userService", "$http", function (modalService, userService, $http) {
  return {
    restrict: 'E',
    scope: {
      branding: '='
    },
    templateUrl: '/static/partials/apps/components/sso-editor.html',
    link: function link(scope) {
      scope.forms = PROVIDERS_FORMS;
      scope.extras = PROVIDERS_EXTRAS;
      var initForms = function initForms() {
        var ssoConfig = scope.branding.sso_config || {};
        if (!ssoConfig) {
          return;
        }
        for (var _i = 0, _Object$keys = Object.keys(ssoConfig); _i < _Object$keys.length; _i++) {
          var configKey = _Object$keys[_i];
          var config = scope.branding.sso_config[configKey];
          if (!config.auto_create_user) {
            config.auto_create_user = {};
          }
          decorateConfig(config, configKey);
        }
      };
      var countConfigOfType = function countConfigOfType(type) {
        var ssoConfig = scope.branding.sso_config;
        var occurrences = 0;
        for (var _i2 = 0, _Object$keys2 = Object.keys(ssoConfig); _i2 < _Object$keys2.length; _i2++) {
          var configKey = _Object$keys2[_i2];
          var config = scope.branding.sso_config[configKey];
          if (config.type === type) {
            occurrences++;
          }
        }
        return occurrences + 1;
      };
      var decorateConfig = function decorateConfig(config, ssoKey) {
        var provider = PROVIDERS.find(function (_ref) {
          var type = _ref.type;
          return type === config.type;
        });
        var conf = config.conf || _.clone(_brandedAppsMetadata.SSO_CONFIG[provider.id].conf);
        var uid = countConfigOfType(provider.type);
        var id = ssoKey || "".concat(config.type, "-").concat(uid);
        if (config.type === 'openidconnect') {
          conf = Object.assign(conf, normalizeOpenIDForm(ssoKey, conf));
        }
        conf.label = conf.label || "".concat(provider.name, " ").concat(uid);
        conf.callbackUrl = conf.callbackUrl || _constants.APP_BRANDING_SSO_CALLBACK.replace('{{branding}}', scope.branding.fp_ext_id).replace('{{id}}', id);
        //  callbackURL is for OAuth, callbackUrl for SAML
        conf.callbackURL = conf.callbackUrl;
        config.auto_create_user = config.auto_create_user || {};

        // SAML default values
        if (provider.type === 'saml' && !conf.issuer) {
          conf.issuer = _constants.APP_BRANDING_SSO_SAML_DEFAULT_ISSUER.replace('{{branding}}', scope.branding.fp_ext_id).replace('{{id}}', id);
        }
        config.provider = provider;
        config.conf = conf;
        config.type = provider.type;
        return id;
      };
      var normalizeOpenIDForm = function normalizeOpenIDForm(id, conf) {
        var model = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PROVIDERS_FORMS['openidconnect'];
        var form = model;
        var keys = [];
        for (var _i3 = 0, _Object$keys3 = Object.keys(form); _i3 < _Object$keys3.length; _i3++) {
          var key = _Object$keys3[_i3];
          if (form[key].kind === 'list') {
            keys.push(key);
          }
        }
        for (var _i4 = 0, _keys = keys; _i4 < _keys.length; _i4++) {
          var secondLevelKey = _keys[_i4];
          if (!_.isArray(conf[secondLevelKey])) {
            var fields = [];
            for (var _i5 = 0, _Object$keys4 = Object.keys(conf[secondLevelKey] || {}); _i5 < _Object$keys4.length; _i5++) {
              var field = _Object$keys4[_i5];
              fields.push({
                key: field,
                value: conf[secondLevelKey][field]
              });
            }
            conf[secondLevelKey] = fields;
          }
        }
        return conf;
      };
      var uploadXml = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(config, xml, id) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", postConfiguration(config, {
                  xml: xml
                }, id));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function uploadXml(_x, _x2, _x3) {
          return _ref2.apply(this, arguments);
        };
      }();
      var postConfiguration = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(config, params, id) {
          var providerExtras, branding, url, _yield$$http$post, data;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
                branding = scope.branding;
                url = providerExtras.configUrl.replace('{{branding}}', branding.fp_ext_id).replace('{{id}}', id);
                _context2.next = 5;
                return $http.post(url, params);
              case 5:
                _yield$$http$post = _context2.sent;
                data = _yield$$http$post.data;
                setConfig(config, data, id);
              case 8:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function postConfiguration(_x4, _x5, _x6) {
          return _ref3.apply(this, arguments);
        };
      }();
      var getConfiguration = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(config, params, id) {
          var providerExtras, branding, url, _yield$$http$get, data;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
                branding = scope.branding;
                url = providerExtras.configUrl.replace('{{branding}}', branding.fp_ext_id).replace('{{id}}', id);
                _context3.next = 5;
                return $http.get(url, params);
              case 5:
                _yield$$http$get = _context3.sent;
                data = _yield$$http$get.data;
                setConfig(config, data, id);
              case 8:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function getConfiguration(_x7, _x8, _x9) {
          return _ref4.apply(this, arguments);
        };
      }();
      var setConfig = function setConfig(config, data, id) {
        try {
          if (data) {
            if (config.type === 'openidconnect') {
              Object.assign(config.conf, normalizeOpenIDForm(id, data.conf || data));
            } else {
              // temp fix (backend fix to come later): remove issuer from config
              // as there is already a default value
              delete data.issuer;
              Object.assign(config.conf, data);
            }
          }
        } catch (error) {
          console.error('Couldn\'t load configuration because the document is malformed');
        }
      };
      scope.$watch('branding.sso_config', initForms);
      scope.isSuperAdmin = userService.isSuperAdmin();
      scope.addSSOConfiguration = function () {
        return modalService.openModalWithForm({
          title: 'Add SSO provider',
          fields: _brandedAppsMetadata.FORMS.addSSOConfiguration,
          saveLabel: 'Add',
          formCanBeSaved: function formCanBeSaved(model) {
            return model.type;
          }
        }).then(function (model) {
          if (typeof scope.branding.sso_config === 'undefined') {
            scope.branding.sso_config = {};
          }
          var config = {
            type: model.type
          };
          var id = decorateConfig(config);
          scope.branding.sso_config[id] = config;
        });
      };
      scope.getCallbackUrl = function (config) {
        // case openIdConnect
        var params = (0, _lodash.get)(config, 'conf.params');
        if ((0, _lodash.isArray)(params)) {
          var redirectUriParam = params.find(function (param) {
            return param.key === 'redirect_url';
          });
          if (redirectUriParam) {
            return redirectUriParam.value;
          }
        }
        return (0, _lodash.get)(config, 'conf.callbackUrl');
      };
      scope.toggleDebug = function (config, id) {
        var debug = scope.branding.sso_config[id].debug;
        if (!debug) {
          var millis = (0, _momentTimezone.default)().add(10, 'day').valueOf();
          debug = Math.round(millis / 1000);
        } else {
          debug = false;
        }
        scope.branding.sso_config[id].debug = debug;
        initForms();
      };
      scope.deleteConfig = function (config, id) {
        if (!window.confirm('Do you want to remove this SSO configuration?')) {
          return;
        }
        delete scope.branding.sso_config[id];
      };
      scope.loadMetadata = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(config, id) {
          var providerEndpoints, branding, url, _yield$$http$get2, data;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                providerEndpoints = PROVIDERS_EXTRAS[config.provider.id];
                if (providerEndpoints) {
                  _context4.next = 3;
                  break;
                }
                return _context4.abrupt("return");
              case 3:
                branding = scope.branding;
                url = providerEndpoints.metadataUrl.replace('{{branding}}', branding.fp_ext_id).replace('{{id}}', id);
                _context4.next = 7;
                return $http.get(url);
              case 7:
                _yield$$http$get2 = _context4.sent;
                data = _yield$$http$get2.data;
                modalService.openModal({
                  template: "\n                            <div class=\"modal-header\">\n                                <h2>".concat(config.provider.name, " metadata</h2>\n                            </div>\n                            <div class=\"modal-body\">\n                                <textarea readonly rows=\"40\">").concat(data, "</textarea>\n                            </div>\n                            <div class=\"modal-footer\">\n                                <button class=\"btn btn-primary\" ng-click=\"$$modal.reject()\">Close</button>\n                            </div>")
                });
              case 10:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x10, _x11) {
          return _ref5.apply(this, arguments);
        };
      }();
      scope.loadDebugInfo = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(config, id) {
          var provider, url, doc, debugLog;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                provider = config.name || id;
                url = _constants.APP_BRANDING_SSO_DEBUG_ENDPOINT.replace('{{branding}}', scope.branding._id);
                _context5.prev = 2;
                _context5.next = 5;
                return $http.get(url);
              case 5:
                doc = _context5.sent;
                _context5.next = 10;
                break;
              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](2);
              case 10:
                debugLog = !doc || !doc.data ? 'No debug document registered yet.' : JSON.stringify(doc.data, null, 2);
                modalService.openModal({
                  template: "\n                            <div class=\"modal-header\">\n                                <h2>Debug response from ".concat(provider, "</h2>\n                            </div>\n                            <div class=\"modal-body\">\n                                <pre>").concat(debugLog, "</pre>\n                            </div>\n                            <div class=\"modal-footer\">\n                                <button class=\"btn btn-primary\" ng-click=\"$$modal.reject()\">Close</button>\n                            </div>")
                });
              case 12:
              case "end":
                return _context5.stop();
            }
          }, _callee5, null, [[2, 8]]);
        }));
        return function (_x12, _x13) {
          return _ref6.apply(this, arguments);
        };
      }();
      scope.loadConfigurationFromFile = function (files, config, id) {
        var providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
        if (!providerExtras.configUrl) return;
        if (!files || !files.length) return;
        var file = files[0];
        var reader = new FileReader();
        reader.readAsText(file, 'UTF-8');
        reader.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return uploadXml(config, this.result, id);
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6, this);
        }));
      };
      scope.loadConfigurationFromUrl = function (config, id) {
        var providerExtras = PROVIDERS_EXTRAS[config.provider.id] || {};
        if (!providerExtras.configUrl) return;
        if (!config.file) return;
        getConfiguration(config, {
          params: {
            url: config.file
          }
        }, id);
      };
      scope.openUserAutoCreate = function (config) {
        var savedConfig = angular.fromJson(angular.toJson(config.auto_create_user || {}));
        var dynEids = (0, _lodash.get)(config, 'auto_create_user.dynamic_eids');
        if (_.isObject(dynEids)) {
          // This happens when you edit the form a second time
          var unnormalizedDynEids = [];
          for (var _i6 = 0, _Object$keys5 = Object.keys(dynEids); _i6 < _Object$keys5.length; _i6++) {
            var eid = _Object$keys5[_i6];
            unnormalizedDynEids.push({
              eid: eid,
              conditions: dynEids[eid]
            });
          }
          config.auto_create_user.dynamic_eids = unnormalizedDynEids;
        }
        var fields = (0, _lodash.get)(config, 'auto_create_user.profile_fields.mapping');
        if (!_.isArray(fields)) {
          // This happens when you edit the form a second time
          var unnormalizedMapping = [];
          if (fields) {
            for (var _i7 = 0, _Object$keys6 = Object.keys(fields); _i7 < _Object$keys6.length; _i7++) {
              var fieldName = _Object$keys6[_i7];
              unnormalizedMapping.push({
                key: fieldName,
                value: fields[fieldName]
              });
            }
          }
          if (!config.auto_create_user.profile_fields) {
            config.auto_create_user.profile_fields = {};
          }
          config.auto_create_user.profile_fields.mapping = unnormalizedMapping;
          fields = unnormalizedMapping;
        }
        var fieldKeys = fields.map(function (field) {
          return field.key;
        });
        modalService.openModal({
          title: 'Auto Create User',
          fields: _.clone(_brandedAppsMetadata.FORMS.sso.auto_create_user),
          saveLabel: 'Save',
          model: config.auto_create_user,
          templateUrl: '/static/partials/apps/auto-create-user-form.html'
        }).then(function (model) {
          var dynEids = model.dynamic_eids;
          var normalizedDynEids = {};
          if (dynEids) {
            var _iterator = _createForOfIteratorHelper(dynEids),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _config = _step.value;
                normalizedDynEids[_config.eid] = _config.conditions;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            model.dynamic_eids = normalizedDynEids;
          }
          var mapping = (0, _lodash.get)(model, 'profile_fields.mapping');
          var normalizedMapping = {};
          if (mapping) {
            var keys = [];
            var _iterator2 = _createForOfIteratorHelper(mapping),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var map = _step2.value;
                normalizedMapping[map.key] = map.value;
                keys.push(map.key);
              }

              // mark previously mapped fields as deleted
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
            var _iterator3 = _createForOfIteratorHelper(fieldKeys),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var key = _step3.value;
                if (!keys.includes(key)) {
                  normalizedMapping[key] = {
                    _to_prune: true
                  };
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            model.profile_fields.mapping = normalizedMapping;
          }
          console.info('AutoCreate model', model);
        }).catch(function () {
          return config.auto_create_user = savedConfig;
        });
      };
    }
  };
}];